<template lang="pug">
.page-research(@keydown.esc="closeEmbeds")
  .container.text-left.mt-5
    h1 {{ $route.meta.h1 || $route.meta.title }}
    nav.research-index(:aria-label="$i18n.locale === 'zh' ? '章節' : 'Chapters'")
      a(href='#information-theory') {{ $t('research.papers.informationTheory.title') }}
      a(href='#generative-audio') {{ $t('research.papers.generativeAudio.title') }}
      a(href='#fantasy-ui') {{ $t('research.papers.fantasyUI.title') }}
    .row.mb-0
      .col-sm-12
        span.tag.k-essay Research Notes · NYU IDM · 2018–2019
    .row
      .col-sm-12
        h2#information-theory {{ $t('research.papers.informationTheory.title') }}
          h4.date {{ $t('research.papers.informationTheory.date') }}
        a(href="/static/The evolution of information theory in the digital era (Final Essay | Media theory D | Che-Yu Wu).pdf" target="_blank") {{ $t('research.papers.informationTheory.linkText') }}
        p {{ $t('research.papers.informationTheory.intro1') }}
        br
        p {{ $t('research.papers.informationTheory.intro2') }}
        br
        p {{ $t('research.papers.informationTheory.intro3') }}
    .row
      .col-sm-12
        h2#generative-audio {{ $t('research.papers.generativeAudio.title') }}
          h4.date {{ $t('research.papers.generativeAudio.date') }}
        br
        .entry-content
          //- 這頁的圖原本放在 2018 年的 NYU 部落格 cheyuideation（圖床 s18798.pcdn.co）。圖床 2026-09 起 502、部落格本身已下架（410）。
          //- 2026-10-03 從 Wayback 找回每張圖存檔過的那一個尺寸，建置時由鏡像（src/data/media-mirror.json，條目有 recovered 欄）換成站內檔；
          //- 其他尺寸沒有存檔，srcset 拿掉。只剩 300 寬的加 .low-res，照原尺寸顯示、不放大。
          p {{ $t('research.papers.generativeAudio.beforeNY') }}
          p {{ $t('research.papers.generativeAudio.weekReading') }}
          p
            a(href='https://teropa.info/loop/#/title') https://teropa.info/loop/#/title
          p {{ $t('research.papers.generativeAudio.websiteIntro') }}
          figure#attachment_254.wp-caption.alignnone
            research-image.wp-image-254(src='https://s18798.pcdn.co/cheyuideation/wp-content/uploads/sites/12292/2018/10/螢幕截圖-2018-10-21-19.41.38-1024x535.png', alt='', width='1024', height='535')
            figcaption.wp-caption-text Music for Airtport
          p
            | (
            a(href='https://teropa.info/loop/#/airports') https://teropa.info/loop/#/airports
            |  )
          p {{ $t('research.papers.generativeAudio.musicForAirport') }}
          p {{ $t('research.papers.generativeAudio.classicalBackground') }}
          p
            research-image.alignnone.wp-image-255(src='https://s18798.pcdn.co/cheyuideation/wp-content/uploads/sites/12292/2018/10/5bf745ca9de501e564bcc66f898fd4b4-1024x791.png', alt='', width='1024', height='791')
          p
            research-image.alignnone.wp-image-256(src='https://s18798.pcdn.co/cheyuideation/wp-content/uploads/sites/12292/2018/10/9d4a50dce3a5dc271040930e5c50e834-1024x664.png', alt='', width='1024', height='664')
          p {{ $t('research.papers.generativeAudio.terryRiley') }}
          figure#attachment_257.wp-caption.alignnone
            research-image.wp-image-257(src='https://s18798.pcdn.co/cheyuideation/wp-content/uploads/sites/12292/2018/10/螢幕截圖-2018-10-21-19.44.03-1024x540.png', alt='', width='1024', height='540')
            figcaption.wp-caption-text Terry Riley, 2014
          p
            a(href='https://teropa.info/loop/#/incplayer') https://teropa.info/loop/#/incplayer
          p {{ $t('research.papers.generativeAudio.generativeMethods') }}
          p {{ $t('research.papers.generativeAudio.dataSonification') }}
          figure#attachment_258.wp-caption.alignnone(style='width: 562px')
            research-image.wp-image-258.low-res(src='https://s18798.pcdn.co/cheyuideation/wp-content/uploads/sites/12292/2018/10/螢幕截圖-2018-10-22-01.17.13-300x151.png', alt='', width='300', height='151')
            figcaption.wp-caption-text Listen to Wikipedia
          p
            a(href='http://listen.hatnote.com/') http://listen.hatnote.com/
          p {{ $t('research.papers.generativeAudio.experiments') }}
          p
            button.research-load(type='button', :ref="el => embedTriggers[1] = el", @click="toggleEmbed(1)", :aria-expanded="!!activeEmbeds[1]") {{ activeEmbeds[1] ? ($i18n.locale === 'zh' ? '關閉' : 'Close') : ($i18n.locale === 'zh' ? '載入' : 'Load') }} · OpenProcessing · 611472
            a.research-source(href='https://www.openprocessing.org/sketch/611472/embed/?plusEmbedHash=YTczMzc0ZGFjNmViMTE5MWRiNGY0NjJhZjM2NDVmZmQ2NjQ5ZDdlODgxNjYwYjg5ZTUxOTcyODMzYmUzMjA2NmEyYmFjMzRmNWJhOTRkZmJjNTI3M2Q3MWM3NWU4Mjc5MDgyMTQxYzU5YjgzZjk0NTE5YTg0MDA3MzE0YjQ2NDhnTlFkbTlKK3lpVjhMVENIU2Y2bTU5NFhqUmk2OVp5bENsWC9RU1lvS2hrZkxUN05oNkNLMnQ5RkpDU0ltTnJrMjFhUURxSkF6dkF2RFRZWDQvdlB3Zz09&plusEmbedTitle=true', target='_blank', rel='noopener') {{ $i18n.locale === 'zh' ? '原始來源 ↗︎' : 'Original source ↗︎' }}
            iframe(title="OpenProcessing · 611472", v-if='activeEmbeds[1]', src='https://www.openprocessing.org/sketch/611472/embed/?plusEmbedHash=YTczMzc0ZGFjNmViMTE5MWRiNGY0NjJhZjM2NDVmZmQ2NjQ5ZDdlODgxNjYwYjg5ZTUxOTcyODMzYmUzMjA2NmEyYmFjMzRmNWJhOTRkZmJjNTI3M2Q3MWM3NWU4Mjc5MDgyMTQxYzU5YjgzZjk0NTE5YTg0MDA3MzE0YjQ2NDhnTlFkbTlKK3lpVjhMVENIU2Y2bTU5NFhqUmk2OVp5bENsWC9RU1lvS2hrZkxUN05oNkNLMnQ5RkpDU0ltTnJrMjFhUURxSkF6dkF2RFRZWDQvdlB3Zz09&plusEmbedTitle=true', width='100%', height='600')
          p
            button.research-load(type='button', :ref="el => embedTriggers[2] = el", @click="toggleEmbed(2)", :aria-expanded="!!activeEmbeds[2]") {{ activeEmbeds[2] ? ($i18n.locale === 'zh' ? '關閉' : 'Close') : ($i18n.locale === 'zh' ? '載入' : 'Load') }} · Music Matrix
            a.research-source(href='//codepen.io/frank890417/embed/preview/PypZeZ/?height=521&theme-id=dark&default-tab=js,result', target='_blank', rel='noopener') {{ $i18n.locale === 'zh' ? '原始來源 ↗︎' : 'Original source ↗︎' }}
            iframe(v-if='activeEmbeds[2]', title='Music Matrix', src='//codepen.io/frank890417/embed/preview/PypZeZ/?height=521&theme-id=dark&default-tab=js,result', width='100%', height='600', frameborder='no', allowfullscreen='allowfullscreen')
              | See the Pen <a href="https://codepen.io/frank890417/pen/PypZeZ/">Music Matrix</a> by Majer @Monoame Design (<a href="https://codepen.io/frank890417">@frank890417</a>) on <a href="https://codepen.io">CodePen</a>.
    .row
      .col-sm-12
        h2#fantasy-ui {{ $t('research.papers.fantasyUI.title') }}
          h4.date {{ $t('research.papers.fantasyUI.date') }}

        .entry-content
          h3 {{ $t('research.papers.fantasyUI.fallInLove') }}
          p {{ $t('research.papers.fantasyUI.intro') }}
          p {{ $t('research.papers.fantasyUI.movieInterfaces') }}
          //- 本節的圖同上：Wayback 只存到 300 寬（9.18.33 那張是自己的 FUI 實驗截圖，原檔也不在本機）
          figure#attachment_209.wp-caption.alignnone(style='width: 572px')
            research-image.wp-image-209.low-res(src='https://s18798.pcdn.co/cheyuideation/wp-content/uploads/sites/12292/2018/10/Batman_vs_Superman_Cyborg_Reveal_screengraphics_by_Jayse_Hansen-300x128.jpg', alt='', width='300', height='128')
            figcaption.wp-caption-text Interface design by Jayse Hansen in "Batman v.s. Superman"
          figure#attachment_213.wp-caption.alignnone(style='width: 579px')
            research-image.wp-image-213.low-res(src='https://s18798.pcdn.co/cheyuideation/wp-content/uploads/sites/12292/2018/10/FUI-Design4-1-300x169.jpg', alt='', width='300', height='169')
            figcaption.wp-caption-text Bradley G Munkowitz's FUI Design
          p
          figure#attachment_214.wp-caption.alignnone(style='width: 582px')
            research-image.wp-image-214.low-res(src='https://s18798.pcdn.co/cheyuideation/wp-content/uploads/sites/12292/2018/10/FUI-Design36-300x133.jpg', alt='', width='300', height='133')
            figcaption.wp-caption-text Scene of FUI in Movies
          h3 {{ $t('research.papers.fantasyUI.psychoPass') }}
          p {{ $t('research.papers.fantasyUI.psychoPassIntro') }}
          figure#attachment_210.wp-caption.alignnone(style='width: 566px')
            research-image.wp-image-210.low-res(src='https://s18798.pcdn.co/cheyuideation/wp-content/uploads/sites/12292/2018/10/Screen-Shot-2018-10-01-at-8.51.24-PM-300x169.png', alt='', width='300', height='169')
            figcaption.wp-caption-text Interface Demonstration in the end song of Psycho-Pass
          p
            | After that, I start to search for some introductions of FUI on the internet. There's a lot of those on Pinterest, and movie posts, and I find that there are famous artists who are noted in the FUI field, which are Ash Thorp, Jayse Hansen, and Bradley G Munkowitz. They design the interface for lots of sci-fi movie, such as
            em Ender's Game
            |  and
            em Total Recall
            | .
          p
            button.research-load(type='button', :ref="el => embedTriggers[3] = el", @click="toggleEmbed(3)", :aria-expanded="!!activeEmbeds[3]") {{ activeEmbeds[3] ? ($i18n.locale === 'zh' ? '關閉' : 'Close') : ($i18n.locale === 'zh' ? '載入' : 'Load') }} · Ender’s Game FUI Reel
            a.research-source(href='//player.vimeo.com/video/87056142?title=0&byline=0&portrait=0&color=8dc7dc', target='_blank', rel='noopener') {{ $i18n.locale === 'zh' ? '原始來源 ↗︎' : 'Original source ↗︎' }}
            iframe(title='Ender’s Game FUI Reel', v-if='activeEmbeds[3]', src='//player.vimeo.com/video/87056142?title=0&byline=0&portrait=0&color=8dc7dc', width='100%', height='320px', allowfullscreen='allowfullscreen')
            br
            em Ender's Game FUI Reel and Breakdowns by Ash Thorp and Jayse Hansen
          h3 {{ $t('research.papers.fantasyUI.professionalPart') }}
          p {{ $t('research.papers.fantasyUI.designDetails') }}
          p
            button.research-load(type='button', :ref="el => embedTriggers[4] = el", @click="toggleEmbed(4)", :aria-expanded="!!activeEmbeds[4]") {{ activeEmbeds[4] ? ($i18n.locale === 'zh' ? '關閉' : 'Close') : ($i18n.locale === 'zh' ? '載入' : 'Load') }} · OBLIVION GFX Montage
            a.research-source(href='//player.vimeo.com/video/64377100?title=0&byline=0&portrait=0&color=8dc7dc', target='_blank', rel='noopener') {{ $i18n.locale === 'zh' ? '原始來源 ↗︎' : 'Original source ↗︎' }}
            iframe(title='OBLIVION GFX Montage', v-if='activeEmbeds[4]', src='//player.vimeo.com/video/64377100?title=0&byline=0&portrait=0&color=8dc7dc', width='100%', height='320px', allowfullscreen='allowfullscreen')
              | <span style="width: 0px;overflow: hidden;line-height: 0" class="mce_SELRES_start">&#65279;</span>
            br
            a(href='https://gmunk.com/OBLIVION-GFX')
              em OBLIVION GFX Montage by Joseph Kosinski
          h3 {{ $t('research.papers.fantasyUI.personalExperiment') }}
          p {{ $t('research.papers.fantasyUI.experimentProcess') }}
          figure#attachment_212.wp-caption.alignnone(style='width: 554px')
            research-image.wp-image-212.low-res(src='https://s18798.pcdn.co/cheyuideation/wp-content/uploads/sites/12292/2018/10/Screen-Shot-2018-10-01-at-9.18.33-PM-300x243.png', alt='', width='300', height='243')
            figcaption.wp-caption-text
              | FUI experiment by Che-Yu Wu(me) (
              a(href='https://www.openprocessing.org/sketch/598254') link
              | )
          h3 {{ $t('research.papers.fantasyUI.conclusion') }}
          p {{ $t('research.papers.fantasyUI.conclusionText') }}
          p  
          h4
            strong {{ $t('research.papers.fantasyUI.references') }}:
          p
            | Movie FUI Collections:
            a(href='https://www.noteloop.com/kit/fui/movie/') https://www.noteloop.com/kit/fui/movie/
          p
            | FUI Pinterest Board:
            a(href='https://www.pinterest.com/kghsu/%E8%99%9B%E6%A7%8B%E4%BB%8B%E9%9D%A2%E8%A8%AD%E8%A8%88fui-design/?lp=true')
              | https://www.pinterest.com/kghsu/%E8%99%9B%E6%A7%8B%E4%BB%8B%E9%9D%A2%E8%A8%AD%E8%A8%88fui-design/?lp=true
          p
            | OBLIVION GFX:
            a(href='https://gmunk.com/OBLIVION-GFX') https://gmunk.com/OBLIVION-GFX
          p
            | A Chinese Design Magzine post introduction of  FUI:
            a(href='https://www.mydesy.com/fui-design') https://www.mydesy.com/fui-design


  site-links
</template>

<script>
import SiteLinks from '@/components/ui/SiteLinks.vue'
import { useI18n } from 'vue-i18n'
import ResearchImage from '@/components/research/ResearchImage.vue'

export default {
  components: { ResearchImage, SiteLinks },
  data() { return { activeEmbeds: {}, embedTriggers: {} } },
  methods: {
    closeEmbeds() {
      const id = Object.keys(this.activeEmbeds).find(id => this.activeEmbeds[id])
      this.activeEmbeds = {}
      if (id) this.$nextTick(() => this.embedTriggers[id]?.focus())
    },
    toggleEmbed(id) {
      this.activeEmbeds[id] = !this.activeEmbeds[id]
      if (!this.activeEmbeds[id]) this.$nextTick(() => this.embedTriggers[id]?.focus())
    }
  },
  setup() {
    const { t } = useI18n()
    return { t }
  }
}
</script>

<style lang="sass">
.page-research
  padding-top: 16px
  img
    margin: auto
    width: 100%
    max-width: 800px
    display: block
    height: auto
    border-radius: 6px
  .row
    margin-bottom: 100px
  h2
    font-size: 2.3rem
    font-family: var(--font-display)
    border-bottom: 1px solid var(--line-2)
    padding-top: 20px
    padding-bottom: 15px
    margin-bottom: 40px
    font-weight: bold
  h4
    margin-top: 15px
    font-size: 1.2rem
    opacity: 0.5
  .date
    float: right
  p
    color: var(--ink-2)
    line-height: 1.8
  a
    color: var(--ink)
    text-decoration: underline
    text-underline-offset: 3px
    &:hover
      color: var(--gold)
  .wp-caption-text
    color: var(--ink-4)
    font-size: 0.9rem
    margin-top: 8px
</style>

<style scoped>
.page-research :deep(figure),.page-research :deep(img),.page-research :deep(iframe){max-width:100%}.page-research :deep(img){height:auto}.page-research :deep(figcaption){overflow-wrap:anywhere}
/* 舊部落格的圖只找回 300 寬的那幾張：照原尺寸，不放大成糊的 */
.page-research :deep(img.low-res){max-width:min(100%,300px)}
</style>

<style scoped>
.page-research > .container { max-width: 960px; }
.research-index { display: grid; gap: 4px; margin: 24px 0; text-align: left; }
.research-index a, .research-load, .research-source { min-height: 44px; padding: 10px 12px; }
.research-load { color: var(--ink); background: var(--tint-2); border: 0; border-radius: var(--r-pill); padding: 10px 22px; cursor: pointer; transition: var(--t-hover); }
.research-load:hover { background: var(--tint-3); }
.research-source { display: inline-flex; align-items: center; }
.research-index a:focus-visible, .research-load:focus-visible, .research-source:focus-visible { outline: 2px solid var(--gold); outline-offset: 3px; }
h2[id] { scroll-margin-top: 100px; }
@media(max-width: 600px) {
  .page-research h2 { font-size: 1.8rem; }
  .page-research h2 .date { float: none; font-size: 1rem; margin-top: 12px; }
  .page-research .row { margin-bottom: 48px; }
  .page-research p { font-size: 17px; overflow-wrap: anywhere; }
}
</style>
